// src/redux/classSlice.js

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import {
  get_studentfee,
  add_studentfee,
  update_studentfee,
  delete_studentfee,
  get_studentfee_list
} from "../Service/ApiServices.js";
import { toast } from "react-toastify";
const getTodayDate = () => {
    const today = new Date();
    const offset = today.getTimezoneOffset();
    today.setMinutes(today.getMinutes() - offset);
    return today.toISOString().split("T")[0];
  };
const initialState = {
  studentfees: [],
  studentfeelist:[],
  studentfeefilterlist:[],
  school_id: "",
  totalPages: 0,
  pageSize: 10,
  count: 0,
  activePage: 1,
  loading: false,
  error: null,
  addLoading: false,
  IsEditing: false,
  formData: {
    student :"",
    fee_structure :"",
    total_amount :"",
    paid_amount :"",
    is_paid :"",
    payment_date :getTodayDate()||"",
  },
  filterData: {
    student: "",
  },
};
// Async Thunks for API Calls
export const fetchstudentfeelist = createAsyncThunk(
    'studentfeetype/fetchstudentfeelist',
    async ({school_id,student_id,session_id,token, signal }, { rejectWithValue }) => {
      try {
        const response = await get_studentfee_list(school_id,student_id,session_id,token, signal);
        if (response.status) {
          return response.response;
        } else {
          return rejectWithValue(response.response.message);
        }
      } catch (error) {
        return rejectWithValue(error.message);
      }
    }
  );

          
  export const fetchfilterstudentfeelist = createAsyncThunk(
    'studentfeetype/fetchfilterstudentfeelist',
    async ({school_id,student_id,token, signal }, { rejectWithValue }) => {
      try {
        const response = await get_studentfee_list(school_id,student_id,token, signal);
        if (response.status) {
          return response.response;
        } else {
          return rejectWithValue(response.response.message);
        }
      } catch (error) {
        return rejectWithValue(error.message);
      }
    }
  );
// Async Thunks for API Calls
export const fetchstudentfee = createAsyncThunk(
  "studentfee/fetchstudentfee",
  async (
    { page, page_size, school_id,student_id,token, signal },
    { rejectWithValue }
  ) => {
    try {
      const response = await get_studentfee(
        page,
        page_size,
        school_id,
       student_id,
        token,
        signal
      );
      if (response.status) {
        return response.response;
      } else {
        return rejectWithValue(response.response.message);
      }
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);
export const createstudentfee = createAsyncThunk(
  "studentfee/createstudentfee",
  async ({ data, school_id, token, signal }, { rejectWithValue }) => {
    try {
      const response = await add_studentfee(data, school_id, token, signal);
      if (response.status) {
        return response.response;
      } else {
        return rejectWithValue(response.response.message);
      }
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);
export const updatestudentfee = createAsyncThunk(
  "studentfee/updatestudentfee",
  async ({ data, token, signal }, { rejectWithValue }) => {
    try {
      const response = await update_studentfee(data, token, signal);
      if (response.status) {
        return response.response;
      } else {
        return rejectWithValue(response.response.message);
      }
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const deletestudentfee = createAsyncThunk(
  "studentfee/deletestudentfee",
  async ({ ids, token, signal }, { rejectWithValue }) => {
    try {
      const response = await delete_studentfee({ ids }, token, signal);
      if (response.status) {
        return response.response;
      } else {
        return rejectWithValue(response.response.message);
      }
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);
// Class Slice
const studentfeeSlice = createSlice({
  name: "studentfees",
  initialState,
  reducers: {
    setActivePage(state, action) {
      state.activePage = action.payload;
    },
    updateFormData(state, action) {
      const { name, value } = action.payload;
      state.formData[name] = value;
    },
    updateFilterData(state, action) {
        const { name, value } = action.payload;
        state.filterData[name] = value;
      },
    EditFormData(state, action) {
      // The action should contain all the fields that need to be updated
      const {
        id,
        student,
        fee_structure,
        total_amount,
        paid_amount,
        is_paid,
        payment_date,
    
      } = action.payload;
      state.formData = {
        id,
        student,
        fee_structure,
        total_amount,
        paid_amount,
        is_paid,
        payment_date,
      };
    },
    resetFormData(state) {
      state.formData = {
        student :"",
    fee_structure :"",
    total_amount :"",
    paid_amount :"",
    is_paid :"",
    payment_date :getTodayDate()||"",

      };
    },
    setstudentfee(state, action) {
      state.studentfees = action.payload;
    },
    setIsEditing(state, action) {
      state.IsEditing = action.payload;
    },
    setPageSize(state, action) {
      state.pageSize = action.payload;
    },
    setSchoolId(state, action) {
      state.school_id = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
    .addCase(fetchstudentfeelist.fulfilled, (state, action) => {
        state.studentfeelist = action.payload.data;
      })
      .addCase(fetchstudentfeelist.rejected, (state, action) => {
        state.studentfeelist = [];

      })
      .addCase(fetchfilterstudentfeelist.fulfilled, (state, action) => {
        state.studentfeefilterlist = action.payload.data;
      })
      .addCase(fetchfilterstudentfeelist.rejected, (state, action) => {
        state.studentfeefilterlist = [];

      })

      // Fetch Classes
      .addCase(fetchstudentfee.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchstudentfee.fulfilled, (state, action) => {
        state.loading = false;
        state.studentfees = action.payload.results;
        state.count = action.payload.count;
        state.totalPages = Math.ceil(action.payload.count / state.pageSize);
      })
      .addCase(fetchstudentfee.rejected, (state, action) => {
        state.loading = false;
        state.studentfees = []
        state.error = action.payload;
      })

      // Add Class
      .addCase(createstudentfee.pending, (state) => {
        state.addLoading = true;
      })
      .addCase(createstudentfee.fulfilled, (state, action) => {
        state.addLoading = false;
        state.studentfees = action.payload.data;
        state.IsEditing = false;
        toast.success(action.payload.message || "Something went wrong!");
      })
      .addCase(createstudentfee.rejected, (state, action) => {
        state.addLoading = false;
        state.error = action.payload;
        toast.info(action?.payload?.message || "Something went wrong!");
        state.IsEditing = false;
      })
      // Update Class
      .addCase(updatestudentfee.pending, (state) => {
        state.addLoading = true;
      })
      .addCase(updatestudentfee.fulfilled, (state, action) => {
        state.addLoading = false;
        state.IsEditing = false;

        toast.success(action?.payload?.message || "Something went wrong!");
      })
      .addCase(updatestudentfee.rejected, (state, action) => {
        state.addLoading = false;
        state.error = action.payload;
        state.IsEditing = false;

        toast.info(action?.payload?.message || "Something went wrong!");
      })
      // Delete Class
      .addCase(deletestudentfee.pending, (state) => {
        state.loading = true;
      })
      .addCase(deletestudentfee.fulfilled, (state, action) => {
        state.loading = false;
        toast.success(action?.payload?.message || "Something went wrong!");
      })
      .addCase(deletestudentfee.rejected, (state, action) => {
        state.loading = false;
        toast.info(action?.payload?.message || "Something went wrong!");
        state.error = action.payload;
      });
  },
});

// Export the actions and the reducer
export const {
  setstudentfee,
  setActivePage,
  updateFormData,
  EditFormData,
  resetFormData,
  setIsEditing,
  setSchoolId,
  setPageSize,
  updateFilterData,

} = studentfeeSlice.actions;
export default studentfeeSlice.reducer;
